import { useEffect } from "react";
import {
  getTotalMeasuredCostsYear1,
  getTotalMeasuredCostsYear2,
  getTotalMeasuredCostsYear3,
} from "../Redux/Actions/totalMeasuredCostsYear";
import {
  getTotalMeasuredHoursYear1,
  getTotalMeasuredHoursYear2,
  getTotalMeasuredHoursYear3,
} from "../Redux/Actions/totalMeasuredHoursYear";

export const TotalMeasuredCostsPerYear = (measuresData, dispatch) => {
  //#region add all costs and hours per year in "Åtgärder", all presented in measures dashboard
  useEffect(() => {
    let isMounted = true;
    if (isMounted) {
      if (measuresData) {
        function addTotalMeasuredCostsYear1() {
          const total = measuresData?.measuresData
            .map((item) => item.object.costs1)
            //add sum of each row
            .reduce((acc, curr) => acc + parseInt(curr, 10), 0);
          dispatch(getTotalMeasuredCostsYear1(total));
        }
        function addTotalMeasuredCostsYear2() {
          const total = measuresData?.measuresData
            .map((item) => item.object.costs2)
            //add sum of each row
            .reduce((acc, curr) => acc + parseInt(curr, 10), 0);
          dispatch(getTotalMeasuredCostsYear2(total));
        }
        function addTotalMeasuredCostsYear3() {
          const total = measuresData?.measuresData
            .map((item) => item.object.costs3)
            //add sum of each row
            .reduce((acc, curr) => acc + parseInt(curr, 10), 0);
          dispatch(getTotalMeasuredCostsYear3(total));
        }
        function addTotalMeasuredHoursYear1() {
          const total = measuresData?.measuresData
            .map((item) => item.object.hours1)
            //add sum of each row
            .reduce((acc, curr) => acc + parseInt(curr, 10), 0);
          dispatch(getTotalMeasuredHoursYear1(total));
        }
        function addTotalMeasuredHoursYear2() {
          const total = measuresData?.measuresData
            .map((item) => item.object.hours2)
            //add sum of each row
            .reduce((acc, curr) => acc + parseInt(curr, 10), 0);
          dispatch(getTotalMeasuredHoursYear2(total));
        }
        function addTotalMeasuredHoursYear3() {
          const total = measuresData?.measuresData
            .map((item) => item.object.hours3)
            //add sum of each row
            .reduce((acc, curr) => acc + parseInt(curr, 10), 0);
          dispatch(getTotalMeasuredHoursYear3(total));
        }

        addTotalMeasuredCostsYear1();
        addTotalMeasuredCostsYear2();
        addTotalMeasuredCostsYear3();
        addTotalMeasuredHoursYear1();
        addTotalMeasuredHoursYear2();
        addTotalMeasuredHoursYear3();
      }
    }
    return () => {
      isMounted = false;
    };
  }, [dispatch, measuresData]);
  //#endregion add all costs and hours per year in measures, all presented in measures dashboard
};
